import React, {Component} from 'react';
import {Row, Col, FormGroup, Input, Button, Form} from 'reactstrap';
import { TransferenceType } from '@autofact-lib/operation-lib-model-notary-platform';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';

const FORMAT = 'YYYY-MM-DD';

class BankTransactionsListFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formFilters: {
                BILLING_PAY_DATE: '',
                TRANSFER_TYPE: '',
                PLATE:'',
                AMMOUNT_IN:'',
                AMMOUNT_OUT:''
            }
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
    }

    handleFilterChange(event) {
        let newFilterData = {};
        newFilterData[event.target.id] = event.target.value;
        newFilterData = Object.assign(this.state.formFilters, newFilterData);
        this.setState({formFilters: newFilterData});
    }

    handleDayChange(propName, selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        this.handleFilterChange({
            target:{
                id: propName,
                value:input.value.trim()
            }
        })
    }

    setFilters() {
        const filters = {};
        for (const filter in this.state.formFilters) {
            if (this.state.formFilters.hasOwnProperty(filter) && this.state.formFilters[filter]) {
                filters[filter] = this.state.formFilters[filter];
            }
        }
        this.props.setFiltersCallback(filters);
    }

    resetFilters() {
        const filters = {
            BILLING_PAY_DATE: '',
            TRANSFER_TYPE: '',
            PLATE:'',
            AMMOUNT_IN:'',
            AMMOUNT_OUT:''
        };
        this.props.setFiltersCallback({});
        this.setState({formFilters: filters});
    }

    render() {
        const transferenceTypeListArray = Object.keys(TransferenceType);
        return (
            <Form className={'px-2'}>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <DayPickerInput
                                onDayChange={(selectedDay, modifiers, dayPickerInput)=>{this.handleDayChange('BILLING_PAY_DATE',selectedDay, modifiers, dayPickerInput)}}
                                formatDate={formatDate}
                                format={FORMAT}
                                value={this.state.formFilters.BILLING_PAY_DATE}
                                parseDate={parseDate}
                                inputProps={{
                                    className:'form-control form-control-sm',
                                    placeholder:'Fecha transacción'
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Input type="select" id="TRANSFER_TYPE" className="form-control-sm"
                                   onChange={this.handleFilterChange}
                                   value={this.state.formFilters.TRANSFER_TYPE}>
                                <option value="">Tipo de contrato</option>
                                {transferenceTypeListArray.map(key=>{
                                    return <option key={key} value={TransferenceType[key].shortLabel}>{TransferenceType[key].shortLabel}</option>
                                })}

                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Input type="text"
                                   id="PLATE"
                                   className="form-control-sm"
                                   placeholder="Patente"
                                   onChange={this.handleFilterChange}
                                   value={this.state.formFilters.PLATE}>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Input type="text"
                                   id="AMMOUNT_IN"
                                   className="form-control-sm"
                                   placeholder="Monto abono"
                                   onChange={this.handleFilterChange}
                                   value={this.state.formFilters.AMMOUNT_IN}>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Input type="text"
                                   id="AMMOUNT_OUT"
                                   className="form-control-sm"
                                   placeholder="Monto cargo"
                                   onChange={this.handleFilterChange}
                                   value={this.state.formFilters.AMMOUNT_OUT}>
                            </Input>
                        </FormGroup>
                    </Col>

                    <Col md={2} className="ml-auto filter-button">
                        <Button className="btn btn-sm btn-primary-darker btn btn-secondary mr-2" onClick={this.setFilters}>Aplicar</Button>
                        <Button className="btn btn-sm btn-primary btn" onClick={this.resetFilters}>Limpiar</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default BankTransactionsListFilters;
